import { EnumWithDescription, ICustomEnumValue } from "../EnumWithDescription";

export enum CahpsSurveyRecipientEnum {
    None = 0,
    HasCahpsRecipient = 1,
    NoEligibleCaregiver = 2,
    Unsolicited = 3
}

class CahpsSurveyRecipientClass extends EnumWithDescription<CahpsSurveyRecipientEnum> {
    public readonly enum = CahpsSurveyRecipientEnum;
    public readonly enumName: string = "CahpsSurveyRecipientEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<CahpsSurveyRecipientEnum>> = new Map([
        [
            "None",
            {
                value: CahpsSurveyRecipientEnum.None,
                name: "None"
            }
        ],
        [
            "HasCahpsRecipient",
            {
                value: CahpsSurveyRecipientEnum.HasCahpsRecipient,
                name: "Select a CAHPS survey recipient"
            }
        ],
        [
            "NoEligibleCaregiver",
            {
                value: CahpsSurveyRecipientEnum.NoEligibleCaregiver,
                name: "No eligible caregiver for the CAHPS survey",
                longDescription:
                    "Select this option if the patient’s caregiver is a nonfamilial legal guardian or nonfamilial paid caregiver and there is no other eligible caregiver residing in the household."
            }
        ],
        [
            "Unsolicited",
            {
                value: CahpsSurveyRecipientEnum.Unsolicited,
                name: "Patient/caregiver made an unsolicited request not to be contacted for the CAHPS survey",
                longDescription:
                    "Select this option to designate the patient/caregiver as No Publicity. No Publicity patients/caregivers are those who request at any time during the hospice stay, without being asked, that the hospice not reveal the patient’s identity to anyone outside the hospice and/or not contact them for the survey."
            }
        ]
    ]);
}

export const CahpsSurveyRecipient = new CahpsSurveyRecipientClass();
